import React from 'react';
import { Clock, Leaf, Heart, Smartphone } from 'lucide-react';

const Benefits = ({ language }) => {
  const texts = {
    en: {
      title: 'Why MobileHub4u',
      subtitle: 'Streaming and download games for the duration of your subscription.',
      benefits: [
        {
          icon: Clock,
          title: 'Simple activation',
          description: 'Enter your number and reply with JA. No app download required.',
        },
        {
          icon: Leaf,
          title: 'All games included',
          description: 'Play and download all provided games while you are subscribed.',
        },
        {
          icon: Heart,
          title: 'Cancel anytime',
          description: 'Send STOP TOP to 804 or contact hotline 0041 44 581 61 61 or email.',
        },
        {
          icon: Smartphone,
          title: 'Salt & Sunrise',
          description: 'CHF 10 per week. 2 SMS/week Salt, 1 SMS/week Sunrise.',
        },
      ],
    },
    de: {
      title: 'Warum MobileHub4u',
      subtitle: 'Streaming- und Download-Spiele für die Dauer deines Abos.',
      benefits: [
        {
          icon: Clock,
          title: 'Einfache Aktivierung',
          description: 'Nummer eingeben und mit JA antworten. Kein App-Download nötig.',
        },
        {
          icon: Leaf,
          title: 'Alle Spiele inklusive',
          description: 'Alle bereitgestellten Spiele spielen und herunterladen während des Abos.',
        },
        {
          icon: Heart,
          title: 'Jederzeit kündbar',
          description: 'STOP TOP an 804 senden oder Hotline 0041 44 581 61 61 bzw. E-Mail.',
        },
        {
          icon: Smartphone,
          title: 'Salt & Sunrise',
          description: 'CHF 10 pro Woche. 2 SMS/Woche Salt, 1 SMS/Woche Sunrise.',
        },
      ],
    },
  };

  const t = texts[language];

  return (
    <section id="section-4" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-4">
            {t.title}
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.benefits.map((benefit, index) => (
            <div
              key={index}
              className="p-6 rounded-2xl bg-slate-800/50 border border-slate-700/50 hover:border-slate-600 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-slate-700/50 flex items-center justify-center mb-4">
                <benefit.icon className="w-6 h-6 text-brand-400" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-white mb-2">
                {benefit.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 flex justify-center">
          <div className="rounded-2xl overflow-hidden border border-slate-700/50 max-w-2xl w-full aspect-video bg-slate-800/50">
            <img
              src="/images/benefits.jpeg"
              alt="MobileHub4u – Vorteile"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
